import Layout from '@/apps/layout/components'
import SuccessStoryDetail from '@/apps/SuccessStoryDetail'
import React from 'react'

const SuccessStoryDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <SuccessStoryDetail />
    </Layout>
  )
}

export default SuccessStoryDetailPage
